<div class="modal-bg" [class.active]="active">
  <div class="modal-content">
    <div class="content">
      <span class="circle">
        <i aria-hidden="true" class="icon-warning"></i>
      </span>
      <p>{{'HEADER_MODULE.EPIRED_SESSION.TEXT' | transloco}}</p>
      <app-ds-button
        [labels]="{ ButtonLabel: 'ACCEPT' | transloco }"
        [size]="buttonSize"
        (click)="onAccept()">
      </app-ds-button>
    </div>
  </div>
</div>